;(function () {

"use strict";

var ValidationMessageTemplate = require('./templates/validation-message.html');

var getValidationMessage = function () {
  var msgs = [
    'All set!',
    'Great job!',
    'Well done!',
    "Looks good!"
  ];

  return msgs[Math.floor(Math.random() * msgs.length)];
};

var EntryView = Backbone.View.extend({
  initialize: function (opts) {
    console.log('init input view');
    opts = opts || {};

    this.name = this.$el.attr('name');
    this.parent = opts.parent;

    /* random validation message */
    this.validationMsg = getValidationMessage();
  },
  reset: function () {
    this.changed = undefined;
    this.$el.removeClass('edited');
    this.removeMessage();
  },
  keydown: function (e) {
    this.parent.onKeydown(this, e);

    if (!this.changed) {
      this.changed = true;
      this.$el.addClass('edited');
      this.parent.onChange(this);
    }
  },
  val: function () {
    return this.$el.val();
  },
  keyup: function (e) {
    this.parent.onKeyup(this, e);
  },
  clientValidate: function () {
    var val = this.$el.val();
    if (val) {
      if (this.$el.attr('type') === 'password') {
        this.pass("That's a good looking password!")
      } else {
        this.pass();
      }
    } else {
      this.fail();
    }
  },
  pass: function (str) {
    this.valid = true;
    str = str || this.validationMsg;
    this.$el.removeClass('fail').addClass('success');
    this.appendMessage(str);
  },
  fail: function (str) {
    this.valid = false;
    str = str || "This field is mandatory.";
    this.$el.removeClass('success').addClass('fail');
    this.appendMessage(str);
  },
  serverValidate: function () {
    var name = this.$el.attr('name');
    var val = this.$el.val();
    var url = this.$el.data('validate-url')+'/'+val;

    if (this.req) { this.req.abort(); }
    this.req = $.get(url, _.bind(function (d) {
      if (d.status === 'success') { 
        this.pass(d.msg);
      } else {
        this.fail(d.msg);
      }
    }, this));
  },
  appendMessage: function (str) {
    if (this.$el.next().hasClass('msg')) { this.$el.next().remove(); }
    var $msg = $(_.template(ValidationMessageTemplate, {variable: 'content'})(str));
    $msg.insertAfter(this.$el);
  },
  removeMessage: function () {
    this.$el.removeClass('success').removeClass('fail');
    if (this.$el.next().hasClass('msg')) { this.$el.next().remove(); }
  },
  validate: function () {
    if (this.$el.data('validate')) {
      if (this.$el.data('validate-url')) {
        this.serverValidate();
      } else {
        this.clientValidate();
      }
    } else {
      this.valid = true;
    }

    return this.valid;
  },
  blur: function (e) {
    this.validate();
    this.parent.onBlur(this);
  },
  destroy: function () {
    this.undelegateEvents();
    $(this.el).removeData().unbind(); 

    // this.remove();
    // Backbone.View.prototype.remove.call(this);
  },
  events: {
    'keydown': 'keydown',
    'keyup': 'keyup',
    'blur': 'blur'
  }
});

module.exports = EntryView;

}());